import React from "react"
import Checkbox from "../Checkbox"
import styles from "./toggleField.module.css"

const ToggleField = ({ checked = false, onChange = () => { }, label, labelContent, description, disabled = false, className = "", elementRef, ...props }) => (
    <button
        type="button"
        ref={elementRef}
        className={`${styles.field} ${checked ? styles.active : ""} ${className}`.trim()}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        aria-pressed={checked}
        {...props}
    >
        <Checkbox checked={checked} />
        <span>
            <span className={styles.labelRow}><strong>{label}</strong>{labelContent && <span className={styles.labelContent} onClick={event => event.stopPropagation()}>{labelContent}</span>}</span>
            {description && <small>{description}</small>}
        </span>
    </button>
)

export default ToggleField
